import React from "react";

export default function PageTitle({
    title,
    color = "#98bcc9",
    fontSize = "24px",
    divider = true,
    marginBottom = "30px",
    children,
  }) {
    return (
      <div style={{ marginBottom }}>
        <h1 style={{ fontSize, color, marginBottom: "10px" }}>{title}</h1>
        {divider && <div style={{ height: "1px", backgroundColor: "#eee" }} />}
        {children}
      </div>
    );
  }